import React, { memo, useState } from 'react'
import { DatePicker } from 'components/forms/DatePicker'
import moment from 'moment-timezone'
import { RadioGroup } from 'transfix-ui/components/RadioGroup'
import {
  CUSTOM_END_DATE,
  EXPIRATION_DATE_OPTIONS,
  EXPIRES_30_DAYS,
} from 'apps/marketplace/utils/constants/rates'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'
import { validateExpirationDate } from 'apps/marketplace/utils/helpers/validation'
import { formatDateForApi } from 'utils/formatDatetime'

interface IExpirationDateProps {
  expirationType: string
  expirationDate: string | null
  onChange: (arg: Partial<ChangeRateData>) => void
}

export const ExpirationDate = memo<IExpirationDateProps>(
  ({ expirationDate, expirationType, onChange }) => {
    const [isExpDateInvalid, setIsExpDateInvalid] = useState(false)
    const onChangeExpiration = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
      // Reset errors
      setIsExpDateInvalid(false)
      onChange({
        expirationType: value,
        expirationDate:
          value === EXPIRES_30_DAYS ? formatDateForApi(moment().add(30, 'days')) : null,
      })
    }

    const onChangeExpireDate = ([date]: string[]) => {
      onChange({ expirationDate: date ? formatDateForApi(date) : '' })
      // Validate expDate
      const validExpDate = validateExpirationDate({
        expirationDate: date,
        expirationType: CUSTOM_END_DATE,
      })
      if (validExpDate) {
        setIsExpDateInvalid(false)
      } else {
        // If selected date is in the past, display error message.
        setIsExpDateInvalid(true)
      }
    }

    const showExpirationDatePicker = expirationType === CUSTOM_END_DATE

    return (
      <>
        <div className='row'>
          <div className='col-md-9' data-test='set-expiration'>
            <RadioGroup
              label='Rate expires'
              name='expiration'
              onOptionChange={onChangeExpiration}
              checked={expirationType}
              options={EXPIRATION_DATE_OPTIONS}
            />
          </div>
        </div>

        {showExpirationDatePicker && (
          <div className='row'>
            <div className='col-md-4'>
              {isExpDateInvalid && (
                <p className='validation-message text-error'>
                  Expiration date must be in the future.
                </p>
              )}
              <DatePicker
                date={expirationDate || ''}
                placeholder='Date'
                onDateChange={onChangeExpireDate}
                // minDate={today}
                dataTest='expiration-date-input'
                id='expiration-date-input'
              />
            </div>
          </div>
        )}
      </>
    )
  }
)
